import { Button, ModalIsland } from "@saviynt/design-system";
import { useIntl } from "react-intl";

interface PreCheckDialogProps {
  isOpen: boolean;
  onConfirm: () => void;
  onCancel: () => void;
  isPending: boolean;
}

export default function PreCheckDialog({
  isOpen,
  onConfirm,
  onCancel,
  isPending,
}: PreCheckDialogProps) {
  const intl = useIntl();

  return (
    <ModalIsland
      kind="warning"
      alertTitle={intl.formatMessage({
        id: "pt3qNF",
        defaultMessage: "Enable SSO",
        description: "Pre-check dialog title",
      })}
      alertSubtitle={intl.formatMessage({
        id: "oFB/IT",
        defaultMessage:
          "Enabling SSO will make it mandatory for all users in this tenant. Password-based login will be disabled.",
        description: "Pre-check dialog warning message",
      })}
      onClose={onCancel}
      isOpen={isOpen}
      isOutsideClickEnabled
      primaryButton={
        <Button
          type="button"
          kind="outlined"
          size="medium"
          onClick={onConfirm}
          isEnabled={!isPending}
          isLoading={isPending}
        >
          {intl.formatMessage({
            id: "NIRSQt",
            defaultMessage: "Enable SSO",
            description: "Pre-check dialog confirm button",
          })}
        </Button>
      }
      secondaryButton={
        <Button type="button" kind="ghost" size="medium" onClick={onCancel}>
          {intl.formatMessage({
            id: "7kTEpQ",
            defaultMessage: "Cancel",
            description: "Pre-check dialog cancel button",
          })}
        </Button>
      }
    />
  );
}
